import React from 'react';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons/faClipboardCheck';

import Authenticated from 'Components/Layouts/Authenticated';
import { PrimaryButton } from 'Components/Button';
import { ModalTrigger } from 'Components/Modal';
import CreateCmsElementRecordModal from 'Components/Partials/Modals/CreateCmsElementRecordModal';
import ViewCmsElementRecords from 'Components/Utilities/ViewCmsElementRecords';

import { translation } from 'Services/TranslationHelpers';
import User from "Services/User";

export default class HealthAndSafety extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        const isViewable = User.isAdmin
            ? true
            : !User.belongsToGroup('Staff');

        return (
            <Authenticated title="Health & Safety" titleIcon={faClipboardCheck}>
                <div className="mb-6">
                    <ModalTrigger
                        component={CreateCmsElementRecordModal}
                        props={{
                            showElementsDropdown: true,
                            element_id: null,
                            element_record_id: null,
                            service_user_id: null,
                            health_and_safety: true
                        }}
                    >
                        <PrimaryButton
                            className="font-league-spartan font-bold text-xl"
                            text={translation('cms', 'health_and_safety_submit')}
                        />
                    </ModalTrigger>
                </div>

                <ViewCmsElementRecords
                    health_and_safety={true}
                    isViewable={isViewable}
                />
            </Authenticated>
        );
    }
}
